import React, { useState, useEffect } from "react";
import FreshChat from "react-freshchat";
import { isMediumOrLargeScreen } from "utils/constants/onboardingStep";
import { useLocation } from "react-router-dom";

const FreshChatComponent = () => {
  const location = useLocation();
  const isStep6 = location.pathname == "/get-started/step6";

  const [hideIcon, setHideIcon] = useState(
    isStep6 ? true : isMediumOrLargeScreen
  );

  useEffect(() => {
    setHideIcon(isStep6 ? true : isMediumOrLargeScreen);
  }, [location.pathname]);

  return (
    <>
      {hideIcon && (
        <FreshChat
          token={process.env.REACT_APP_FRESH_CHAT_TOKEN}
          tags={["clientonboarding"]}
        />
      )}
    </>
  );
};

export default FreshChatComponent;
